// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__UDDYf","hideLoader":"Loader_hideLoader__YRdz2","loaderAbsolute":"Loader_loaderAbsolute__hdSgk"};